import { CircularProgress } from '@mui/material'

export const Spinner = () => {
  return <CircularProgress aria-label="処理中" />
}
